import { TrackingClient } from '@sparefoot/tracking-client';
import { lifecycle, compose } from 'recompose';
import { connect } from 'react-redux';

// Selector function to get meta title
const getPageMetaTitle = (state) => state.pageMeta?.tags?.title || 'Default Title';

function withPageViewTracking(page) {
	return compose(
		connect((state) => ({
			pageTitle: getPageMetaTitle(state),
		})),
		lifecycle({
			componentDidMount() {
				if (typeof window !== 'undefined') {
					TrackingClient.trackPageView({
						page_name: this.props.pageTitle, // Dynamic page title
						page_type: page,
					});
				}
			},
		})
	);
}

export default withPageViewTracking;
